import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "../pages/admin/AdminLayout.jsx";
import AdminHome from "../pages/admin/AdminHome.jsx";
import AdminComments from "../pages/admin/AdminComments.jsx";
import AdminTeachers from "../pages/admin/AdminTeachers.jsx";
import AdminDeletes from "../pages/admin/AdminDeletes.jsx";

const AdminRouter = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="/home" element={<AdminHome />} />
        <Route path="/admin/comments" element={<AdminComments />} />
        <Route path="/admin/teachers" element={<AdminTeachers />} />
        <Route path="/admin/deletes" element={<AdminDeletes />} />
        <Route path="/admin" element={<Navigate to="/admin/comments" replace />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Route>
    </Routes>
  );
};

export default AdminRouter;
